import { render } from "./KassensystemAuswahl.vue?vue&type=template&id=12489732&scoped=true"
import script from "./KassensystemAuswahl.vue?vue&type=script&lang=js"
export * from "./KassensystemAuswahl.vue?vue&type=script&lang=js"

import "./KassensystemAuswahl.vue?vue&type=style&index=0&id=12489732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12489732"]])

export default __exports__